/*
 * AdminUsers Messages
 *
 * This contains all the text for the AdminUsers component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  mailInvitations: {
    id: 'app.components.AdminUsers.mailInvitations',
    defaultMessage: 'Email Invitations',
  },
  printInvitations: {
    id: 'app.components.AdminUsers.printInvitations',
    defaultMessage: 'Print Invitations',
  },
  users: {
    id: 'app.containers.Dashboard.users',
    defaultMessage: 'Users',
  },
  inviteParents: {
    id: 'app.components.AdminUsers.inviteParents',
    defaultMessage: 'Invite Parents',
  },
  printParents: {
    id: 'app.components.AdminUsers.printParents',
    defaultMessage: 'Select the classes for which you want to print the invitations.{br}Invitations will only be printed for the parents of students without active (registered) parents.',
  },
  studentsWithoutParents: {
    id: 'app.components.AdminUsers.studentsWithoutParents',
    defaultMessage: 'Students without parents',
  },
  class: {
    id: 'app.components.AdminGroups.class',
    defaultMessage: 'Class',
  },
  inviteEmployees: {
    id: 'app.components.AdminUsers.inviteEmployees',
    defaultMessage: 'Invite Employees',
  },
  inviteStudents: {
    id: 'app.components.AdminUsers.inviteStudents',
    defaultMessage: 'Invite Students',
  },
  printStudents: {
    id: 'app.components.AdminUsers.printStudents',
    defaultMessage: 'Students can activite their account using the Connection Code in the invitation.{br}Select the classes for which you want to print the invitations.',
  },
  studentsWithoutAccount: {
    id: 'app.components.AdminUsers.studentsWithoutAccount',
    defaultMessage: 'Students without account',
  },
  inviteByEmail: {
    id: 'app.components.AdminUsers.inviteByEmail',
    defaultMessage: 'Do you have a list of email addresses of the {roleType, select, parent {parents} employee {employees}  other {??}}? Then you can invite them all at once by email.',
  },
  printEmployees: {
    id: 'app.components.AdminUsers.printEmployees',
    defaultMessage: 'Select the employees for whom you want to print the invitations. You can only print for employees that don\'t have an active account yet.',
  },
  employee: {
    id: 'app.components.UsersByRole.employee',
    defaultMessage: 'Employees',
  },
  parent: {
    id: 'app.components.UsersByRole.parent',
    defaultMessage: 'Parents',
  },
  student: {
    id: 'app.components.UsersByRole.student',
    defaultMessage: 'Students',
  },
  invitePrintButton: {
    id: 'app.components.AdminUsers.invitePrintButton',
    defaultMessage: 'Open Page',
  },
  emailAddress: {
    id: 'app.common.emailAddress',
    defaultMessage: 'Email Address',
  },
  send: {
    id: 'app.common.send',
    defaultMessage: 'Send',
  },
  sendInvitationByEmail: {
    id: 'app.components.AdminUsers.sendInvitationByEmail',
    defaultMessage: 'Send the invitation to an email address.',
  },
  addEmail: {
    id: 'app.components.AdminUsers.addEmail',
    defaultMessage: 'Add Email Address',
  },
  invitationsSent: {
    id: 'app.components.AdminUsers.invitationsSent',
    defaultMessage: 'The {count, plural, one {invitation has} other {invitations have}} been sent',
  },
});
